export default {"src":"/_next/static/media/check_mark.172183ad.svg","height":91,"width":91};